export default __webpack_public_path__ + "static/media/hipertension_embarazo.ef4620ed.pdf";